import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import bTWhiteLogo from "@assets/bt-icon-white.svg";
import Container from "@components/Container/Container";
import SubscribeTrigger from "@components/Header/SubscribeTrigger/SubscribeTrigger";
import PosthogFeature from "@components/Posthog/PosthogFeature";
import { formatDateToReadable } from "@events-awards/utils/helpers";
import MyAccountHeader from "@pages/MyAccount/components/MyAccountHeader/MyAccountHeader";
import MyAccountPopoverLogin from "@pages/MyAccount/components/MyAccountPopoverLogin/MyAccountPopoverLogin";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { cn } from "@util/helpers";

/**
 * Component to render Event Awards Header
 */
const EventsAwardsHeader = (): React.ReactElement => {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);

  const userDisplayName = OKTAUserInfo?.display_name || OKTAUserInfo?.loginid;
  const displaySubscribe =
    OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER;

  return (
    <header
      data-testid="events-awards-header-component"
      className="mb-4 w-full flex-none bg-gray-850 md:mb-8"
    >
      <Container rootClassName="flex flex-row justify-between items-center py-2">
        <Link to={RouteFactory.home}>
          <img
            src={bTWhiteLogo}
            alt="Business Times logo"
            width={200}
            height={20}
          />
        </Link>

        <p className="mb-0 hidden font-poppins text-4xs uppercase text-white lg:block">
          {formatDateToReadable()}
        </p>

        <div className={"items-center sm:flex sm:flex-col md:flex-row"}>
          {displaySubscribe ? (
            <div className="flex flex-col items-end">
              <PosthogFeature flagName="feature_enable_user_login">
                <SubscribeTrigger rootClassName="text-base" />
              </PosthogFeature>
            </div>
          ) : null}

          <div
            className={cn("flex justify-end", {
              "md:ml-3": displaySubscribe,
              "mr-4 mt-1 md:mr-0": userDisplayName && displaySubscribe,
            })}
          >
            {userDisplayName ? (
              <MyAccountHeader textClassName="text-white hover:text-gray-250 lg:hover:bg-gray-850" />
            ) : (
              <PosthogFeature flagName="feature_enable_user_login">
                <MyAccountPopoverLogin
                  isSiaPage
                  textClassName="w-[160px] pr-0 md:w-full pr-3 text-left whitespace-normal break-words"
                />
              </PosthogFeature>
            )}
          </div>
        </div>
      </Container>
    </header>
  );
};

export default EventsAwardsHeader;
